/**
 * Create an identifying reward key by combining campaign id with reward number.
 */
export default (campaignId, rewardNumber) => `${campaignId}-${rewardNumber}`;



// WEBPACK FOOTER //
// ./src/utilities/getRewardKey.js